import React, {useState} from 'react'
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome"
import {faBars, faChevronDown, faSearch} from "@fortawesome/free-solid-svg-icons"
import {faTimes} from "@fortawesome/pro-regular-svg-icons"
import {graphql, useStaticQuery} from "gatsby"
import "../styles/header.scss"


const Header = () => {
    const [isOpen, toggleOpen] = useState(false)

    function toggleSearch(e) {
        e.preventDefault()

        const searchForm = document.getElementById('search-form-desktop')
        searchForm.classList.toggle('open')
    }

    const data = useStaticQuery(graphql`
        query Header {
            allWpMenu {
                nodes {
                    name
                    menuItems {
                        nodes {
                            id
                            label
                            url
                            path
                            parentId
                        }
                    }
                }
            }
            wp {
                siteLogo {
                    sourceUrl
                }
            }
            wp {
                siteLogo {
                    sourceUrl
                }
            }
        }
    `)

    const flatListToHierarchical = (
        data = [],
        {idKey = "id", parentKey = "parentId", childrenKey = "children"} = {}
    ) => {
        const tree = []
        const childrenOf = {}
        data.forEach(item => {
            const newItem = {...item}
            const {[idKey]: id, [parentKey]: parentId = 0} = newItem
            childrenOf[id] = childrenOf[id] || []
            newItem[childrenKey] = childrenOf[id]
            parentId
                ? (childrenOf[parentId] = childrenOf[parentId] || []).push(newItem)
                : tree.push(newItem)
        })
        return tree
    }


    const $hierarchicalList = flatListToHierarchical(data.allWpMenu.nodes.find(menu => menu.name === 'Header').menuItems.nodes)

    return (
        <header className="header container">
            <a className="header__logo" href="/">
                <img className="header__logo__image" src={data.wp.siteLogo.sourceUrl} alt=""/>
            </a>
            <nav className="header__nav header__nav--desktop">
                <ul>
                    {$hierarchicalList.filter(item => item.parentId === null).map((item, index) =>
                        <li key={index}>
                            <a href={item.path}>{item.label} {item.children.length > 0 &&
                            <i><FontAwesomeIcon icon={faChevronDown}/></i>}</a>
                            {item.children.length > 0 &&
                            <ul className="header__nav--desktop__child">
                                {item.children.map((child, index) =>
                                    <li key={index}><a href={child.path}>{child.label}</a></li>
                                )}
                            </ul>
                            }
                        </li>
                    )}
                </ul>
                <a href="/get-updates">Get Updates</a>
            </nav>
            <div className="header__search--desktop">
                <a id="search-button" onClick={toggleSearch} href="#">
                    <FontAwesomeIcon icon={faSearch} size="lg"/>
                </a>
                <form action="/search" id="search-form-desktop">
                    <input name="q" type="text" placeholder="Type to search"/>
                </form>
            </div>
            <button className="header__toggle" id="toggle-button" onClick={() => toggleOpen(!isOpen)}>
                {isOpen ? (
                    <FontAwesomeIcon className="header__toggle__open" icon={faTimes} size="2x"/>
                ) : (
                    <FontAwesomeIcon className="header__toggle__open" icon={faBars} size="2x"/>
                )}
            </button>
            <nav className={`header__nav header__nav--mobile ${isOpen ? 'open' : ''}`}>
                <ul>
                    {data.allWpMenu.nodes.find(menu => menu.name === 'Mobile Header Left').menuItems.nodes.map((item, index) =>
                        <li key={index}>
                            <a href={item.url}>{item.label}</a>
                        </li>
                    )}
                </ul>
                <ul>
                    {data.allWpMenu.nodes.find(menu => menu.name === 'Mobile Header Right').menuItems.nodes.map((item, index) =>
                        <li key={index}>
                            <a href={item.url}>{item.label}</a>
                        </li>
                    )}
                </ul>
                <form action="/search">
                    <input name="q" type="text" placeholder="Type to search"/>
                    <span><FontAwesomeIcon icon={faSearch} size="lg"/></span>
                </form>
            </nav>
        </header>
    )
}

export default Header
